import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AllOutIcon(props: IconProps) {
    return <Icon {...props} iconKey={"all_out"}/>
}
